// extracted by mini-css-extract-plugin
export default {"boxInput__input":"SearchInput_boxInput__input__+xqN6","boxInput":"SearchInput_boxInput__loBIh","boxInput__icon":"SearchInput_boxInput__icon__goMHl"};